<template>
  <div>
    <div class="w-full  ">
      <div
        class="text-custom text-center md:text-left text-xl lg:text-2xl mb-5 md:mb-0 leading-none font-medium"
      >
        Subscribers
      </div>

      <!-- component -->
      <div class="py-8">
        <div class="shadow overflow-y-hidden rounded-lg">
          <table class="table-auto w-full">
            <thead class="bg-custom text-white">
              <tr>
                <th>No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Subscription status</th>
                <th>Subscriber since</th>
                <th>Subscription Plan</th>
                <th>Subscription Start</th>
                <th>Subscription End</th>
              </tr>
            </thead>
            <tbody class="text-white" style="background: rgba(64, 64, 64, 0.8)">
              <tr v-for="(key, index) in Object.keys(subscribers)" v-bind:key="key">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ subscribers[key].displayName }}
                </td>
                <td>
                  {{ subscribers[key].email }}
                </td>
                <td>
                  {{ subscribers[key].status }}
                </td>
                <td>
                  {{ subscribers[key].start ? moment(subscribers[key].start * 1000).local().fromNow() : '-' }}
                </td>
                <td>
                  {{ subscribers[key].planInterval }}
                </td>
                <td>
                  {{ subscribers[key].currentStartPeriod ? moment(subscribers[key].currentStartPeriod * 1000).local().format('DD/MM/YYYY') : '-' }}
                </td>
                <td>
                  {{ subscribers[key].currentStartPeriod ? moment(subscribers[key].currentEndPeriod * 1000).local().format('DD/MM/YYYY') : '-' }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Layout from "@/views/admin/Layout.vue";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "Tickets",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Ticket",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  /* components: {
    Layout
  }, */
  data() {
    return {
      subscribers: {},
      moment: moment
    };
  },
  mounted() {
    firebase
      .database()
      .ref("subscriptions")
      .once('value',(data)=>{
        this.subscribers = data.val() || {};
      })
  }
};
</script>

<style lang="postcss" scoped>
table thead tr th {
  @apply text-left py-5 px-4 uppercase font-semibold text-sm;
}
table tbody tr {
  @apply border-b border-gray-300;
}
table tbody tr td {
  @apply text-left py-3 px-4 border-r border-gray-300;
}
table tbody tr td:last-child,
table tbody tr:last-child {
  @apply border-none;
}
table tbody tr td:not(:nth-child(2)) {
  text-align: center;
}
</style>
